import React from "react";
import _ from "lodash";
import { Divider } from "semantic-ui-react";
import { Div } from "@components/Generics.react";

export default function LineBulletList(props) {
    const { bullets, caption } = props.data;
    const getOptions = _.map(bullets, (item, index) => {
        return <li key={index}>{item}</li>;
    });

    return (
        <Div superpad big>
            <Div fluid bold zoom>
                {caption}
            </Div>
            <Divider />
            <ul style={{ marginLeft: "-15px" }}>{getOptions}</ul>
        </Div>
    );
}
